import { appConfig } from '../config';

/** GTW base URL for WhatsApp media (origin only, no path). Media works only via gtw. */
export function getGtwMediaBaseUrl(): string {
  try {
    const urlRest = appConfig.URL_REST || '';
    if (urlRest) {
      const u = new URL(urlRest);
      return u.origin;
    }
    const metaUrl = appConfig.META_URL || '';
    if (metaUrl) {
      const u = new URL(metaUrl);
      return u.origin;
    }
  } catch {
    // ignore
  }
  return '';
}

/** Extract media id from URL path like .../media/{id} or .../media/{id}.jpg */
export function getMediaIdFromUrl(url: string): string | null {
  const match = typeof url === 'string' && url ? url.match(/\/media\/([^/?#]+)/i) : null;
  return match ? match[1] : null;
}

const WHATSAPP_MEDIA_PATH = '/whatsapp/api/media';

/** Build WhatsApp media URL via GTW for a given media id. */
export function buildGtwWhatsAppMediaUrl(mediaId: string): string {
  const base = getGtwMediaBaseUrl();
  return base ? `${base}${WHATSAPP_MEDIA_PATH}/${mediaId}` : '';
}
